export default [
  {
    path: '/deliveryOrder',
    name: 'deliveryOrder',
    component: () => import('@/pages/stationMissionCenter/deliveryOrder/index.vue'),
    meta: {
      title: '要交车订单',
      storeKey: '*'
    }
  },
  {
    path: '/orderDetail',
    name: 'orderDetail',
    component: () => import('@/pages/stationMissionCenter/orderDetail/index.vue'),
    meta: {
      title: '订单明细',
      storeKey: '*'
    }
  },
  {
    path: '/carDetail',
    name: 'carDetail',
    component: () => import('@/pages/stationMissionCenter/carDetail/index.vue'),
    meta: {
      title: '车辆明细',
      storeKey: '*'
    }
  }
]



// WEBPACK FOOTER //
// ./src/router/stationMissionCenter/deliveryOrder.js